import { create } from "zustand";
import { getCommunityDetails, getCommunityOrderStats,downloadCommunity } from "../api";

export const useCommunityDetails = create((set) => ({
  communityDetails: [],
  communityDownloadData:[],
  isLoading: false,
  downloading:false,
  error: null,
  fetchCommunityDetails: async (id, page) => {
    try {
      set({ isLoading: true, error: null });
      const response = await getCommunityDetails(id, page);
      set({ communityDetails: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
}));

export const useCommunityOrderStats = create((set) => ({
  communityOrderStats: [],
  communityDownloadData:[],
  statsLoading: false,
  error: null,
  fetchCommunityOrderStats: async (id) => {
    try {
      set({ statsLoading: true, error: null });
      const response = await getCommunityOrderStats(id);
      set({ communityOrderStats: response.data, statsLoading: false });
    } catch (error) {
      set({ error: error.message, statsLoading: false });
    }
  },
  fetchCommunityDownload: async (id) => {
    try {
      set({ downloading: true, error: null });
      const response = await downloadCommunity(id);
      set({ communityDownloadData: response.data, downloading: false });
    } catch (error) {
      set({ error: error.message, downloading: false });
    }
  },
}));

